import TBancoMain from "./TBancoMain"
import FBancoMain from "./FBancoMain"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { obtenerBancosAllAction } from "../../../ducks/bancoGeneralDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
export const BancoMain = () => {
    const dispatch = useDispatch()
    const { bancosMain, editar } = useSelector(store => store.bancoMain)
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerBancosAllAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
    return (
        <div>
            {
                (bancosMain.length === 0 || editar) ? <FBancoMain /> : <TBancoMain />
            }
        </div>
    )
}
export default BancoMain